import { ReactComponent as QuoteMarkOpen } from '@/assets/quote-mark-open.svg'
import { ReactComponent as QuoteMarkClose } from '@/assets/quote-mark-close.svg'

export function Testimonial() {
  return (
    <div className='fv:relative fv:max-w-md'>
      {/* Opening quote mark */}
      <QuoteMarkOpen className='fv:absolute fv:-top-10 fv:-left-6 fv:w-20 fv:h-auto' />

      {/* Quote text */}
      <p className='fv:text-2xl fv:font-light fv:text-off-white fv:leading-snug'>
        'Work smarter, not harder,' they said.{' '}
        <span className='fv:font-semibold fv:bg-gradient-to-r fv:from-orange-600 fv:to-yellow-200 fv:bg-clip-text fv:text-transparent'>
          Fathom took it personally.
        </span>
      </p>

      {/* Closing quote mark */}
      <QuoteMarkClose className='fv:absolute fv:-right-4 fv:-bottom-4 fv:w-20 fv:h-auto fv:rotate-180' />

      {/* Author */}
      <div className='fv:flex fv:items-center fv:gap-3 fv:mt-5'>
        <div className='fv:text-xs fv:text-off-white/75'>
          <p className='fv:font-medium'>Rosanne K.</p>
          <p className='fv:font-light'>Executive</p>
        </div>
      </div>
    </div>
  )
}
